module.exports = "pegasus/assets/lp/ebook/logo.png";